<div class="row" [formGroup]="formGroup">
    <div class="col">
        <div class="float-end">
            <button class="btn btn-sm btn-outline-danger" (click)="displayDeleteChallengeDetail()" *ngIf="!deleteChallengeDetailVisible">
                <i class="fas fa-times"></i> Remove
            </button>
            <button class="btn btn-sm btn-danger" (click)="deleteChallengeDetail()" *ngIf="deleteChallengeDetailVisible">
                <i class="fas fa-exclamation-circle"></i> Confirm
            </button>
        </div>
        <div class="mb-3">
            <label for="challengeDetailDetailInput_{{ challenge.id }}_{{ formGroup.value.challengeDetailLocaleInput }}">Description (Locale "{{ formGroup.value.challengeDetailLocaleInput }}")</label>
            <textarea type="text" class="form-control" id="challengeDetailDetailInput_{{ challenge.id }}_{{ formGroup.value.challengeDetailLocaleInput }}" formControlName="challengeDetailDetailInput" readonly></textarea>
        </div>
    </div>
</div>